var target_form_template = require('./target_form.twig');

import { GoogleAddressAutocomplete } from "../../helpers/GoogleAddressAutocomplete"
import { Dropdown } from '../../components/Dropdown'
import { CustomModal } from '../../components/customModal'

export class TargetForm {
  constructor(meetingPhase, attendeeData, meetingData) {
    this.meetingPhase = meetingPhase;
    this.attendeeData = attendeeData;
    this.meetingData = meetingData;
    this.type = "target";
    this.attendeeData.att_type = this.type;
    this.irep_validations = app.appData.configs?.ATTENDEE_FIELD_IREP_VALIDATION ?? false;
    this.fields = app.appData.layout.attendance.form_fields[this.type][this.meetingPhase] ?? {};
    this.questionsFields = this.getQuestionFields();
    this.requiredFields = this.getRequiredFields();
    this.questions = this.generateFieldConfig(
      this.questionsFields,
      this.requiredFields
    );
    this.targetFields = this.mergeObjects(this.questions, this.fields);
    let templateData = {data: target_form_template};

    this.dom = $(
      twig(templateData).render({
        appData: app.appData,
        meetingPhase: this.meetingPhase,
        meetingData: this.meetingData,
        attendeeData: this.attendeeData,
        fields: this.targetFields,
        int_company_name: app.appData.supportInfo.int_company_name,
        degree_title: app.appData.layout.attendance.degree_title,
        has_meals: app.appData.serviceTypes[this.meetingData.service_id]
          ? app.appData.serviceTypes[this.meetingData.service_id].has_meals
          : false,
      })
    );

    this.dom.on("shown.bs.modal", () => {
      if (this.targetFields["address1"]) {
        new GoogleAddressAutocomplete("attendance_target_form_address");
      }
    });

    this.dom.find("#address1").on("focus", () => {
      $("#state_license, #license_country, #license_state").attr(
        "autocomplete",
        "no"
      );
    });

    this.dom.on("hidden.bs.modal", () => {
      $("#target_form_modal").remove();
      this.modal.dispose();
    });

    this.setupDropdowns();
    this.setRequiredFields();
    this.setFormVals();
    this.checkRequired();
    this.populateHiddenFields();
    this.toggleFields();

    this.dom.find(".postalcode").mask("99999[-9999]");
    this.dom.find(".phonenumber").mask("(999) 999-9999");

    this.dom.find("#prev-addresses").on("change", () => {
      let currCountry = this.dom.find("#country").val();
      let data = this.dom.find("#prev-addresses :selected").data();
      Object.keys(data).forEach((key) => {
        if (
          key != "state" ||
          (key == "state" && currCountry == data["country"])
        ) {
          this.dom.find("#" + key + ".address-field").val(data[key]);
        } else {
          this.buildStateDD(
            this.dom.find("#state-dd-container"),
            "state",
            data["country"],
            data[key]
          );
        }
      });
    });

    this.dom.find(".country-dd").on("change", (event) => {
      let data = $(event.target).data();
      let countryAbbrv = $(event.target).val();

      this.buildStateDD(
        this.dom.find("#" + data.stateDdContainer),
        data.stateDdId,
        countryAbbrv
      );
      this.dom.find('[name="address1"], [name="city"]').trigger("keyup");
    });

    this.dom.on("change", ".pattern-valid", () => {
      $("#target_form")[0].reportValidity();
    });

    this.dom
      .find("#target_form input, #target_form select, #target_form .select2")
      .on("change blur", (event) => {
        var targetValue = $(event.target).val();

        if (targetValue !== null && targetValue !== undefined) {
          $(event.target).val(targetValue.trim());
        }

        this.checkRequired();
        this.checkInvalidEmail();
        this.checkInvalidNpiNumber(this.dom.find("#npi_num").val());
      });

    this.dom
      .find("#npi_num")
      .off("blur")
      .on("input", () => {
        var npi_number = this.dom.find("#npi_num").val();

        if (npi_number !== null && npi_number !== undefined) {
          npi_number = npi_number.toString().trim();
          this.checkInvalidNpiNumber(npi_number);
        }
      });

    this.dom
      .find('input[name="email"]')
      .off("blur")
      .on("input", () => {
        this.checkInvalidEmail();
      });

    if (this.irep_validations) {
      const fieldsToValidate = [
        "firstname",
        "lastname",
        "address1",
        "address2",
        "city",
        "zip",
      ];

      fieldsToValidate.forEach((fieldId) => {
        const $input = this.dom.find("#" + fieldId);

        // Live input validation
        $input.off("blur").on("input change", () => {
          const value = $input.val();
          const error = this.validateField(value, fieldId);

          $input[0].setCustomValidity(error);
          $input.removeClass("is-invalid");
          if (error) $input.addClass("is-invalid");
        });

        //Initial validation when modal loads / form is set
        const initialValue = $input.val();
        const initialError = this.validateField(initialValue, fieldId);

        $input[0].setCustomValidity(initialError);
        $input.removeClass(" is-invalid");
        if (initialError) $input.addClass("is-invalid");
      });
    }

    this.checkInvalidEmail();
    this.checkInvalidNpiNumber(this.dom.find("#npi_num").val());

    this.dom.find("#is_fed_emp").on("change", (event) => {
      let val = $(event.target).val();
      if (val == 1) {
        this.dom.find("#is_state_emp").val("0").trigger("change");
      }
    });

    this.dom.find("#is_state_emp").on("change", (event) => {
      let val = $(event.target).val();
      if (val == 1) {
        this.dom.find("#is_fed_emp").val("0").trigger("change");
      }
    });

    this.dom
      .find("#license-state-dd-container")
      .on("change", "#license_state", () => {
        this.setRequiredForLicenseStateNumber();
      });

    this.dom.find("#license_number").on("change", () => {
      this.setRequiredForLicenseStateNumber();
    });

    this.dom.find("#received_article_reprint_yes").on("change", () => {
      if (this.dom.find("#received_article_reprint_yes").prop("checked")) {
        this.dom
          .find("#article_reprint_count")
          .prop("required", true)
          .addClass("required is-invalid");
      }
      this.dom.find(".article_reprint_count-container").show();
    });

    this.dom.find("#received_article_reprint_no").on("change", () => {
      if (this.dom.find("#received_article_reprint_no").prop("checked")) {
        this.dom
          .find("#article_reprint_count")
          .prop("required", false)
          .removeClass("required is-invalid");
      }
      this.dom.find(".article_reprint_count-container").hide();
    });

    if (
      (this.targetFields["email"] ?? false) &&
      (this.targetFields["wwid"] ?? false) &&
      this.targetFields["email"]["required"] &&
      this.targetFields["wwid"]["required"]
    ) {
      this.dom.find('input[name="email"]').on("keyup", () => {
        this.validateEitherEmailOrWwidField();
      });
      this.dom.find('input[name="wwid"]').on("keyup", () => {
        this.validateEitherEmailOrWwidField();
      });
    }

    this.dom.find("#degree").on("change", (event) => {
      let otherDegrees = app.appData.layout.attendance.other_degrees;
      let degreeElem = this.dom.find("#degree");
      let field = app.appData.layout.attendance.degree_title
        ? "#title"
        : "#degree_other";
      let container = app.appData.layout.attendance.degree_title
        ? ".title-container"
        : ".degree-other-container";
      let prescriberReqFields = ["specialty", "license_state", "state_license"];

      if (app.appData.layout.attendance.disassociate_degree ?? false) {
        prescriberReqFields.splice(prescriberReqFields.indexOf("specialty"), 1);
      }

      if (otherDegrees.includes(degreeElem.val())) {
        if (degreeElem.prop("required")) {
          this.dom
            .find(field)
            .prop("required", true)
            .addClass("required is-invalid");
        }

        this.dom.find(container).show();
      } else {
        this.dom
          .find(field)
          .prop("required", false)
          .removeClass("required is-invalid")
          .val("");
        this.dom.find(container).hide();
      }

      const is_prescriber =
        this.dom.find("option:selected", event.target).data("is_prescriber") ==
        1;
      for (const field of prescriberReqFields) {
        if (
          this.targetFields[field] &&
          this.targetFields[field]["required"] &&
          is_prescriber
        ) {
          this.dom
            .find("#" + field)
            .prop("required", true)
            .addClass("required is-invalid");
        } else {
          this.dom
            .find("#" + field)
            .prop("required", false)
            .removeClass("required is-invalid");
        }
      }

      if (
        !(app.appData.configs.DISASSOCIATE_DEGREE_NPI ?? false) &&
        !(app.appData.layout.attendance.disassociate_degree ?? false)
      ) {
        if (
          this.targetFields["npi_num"] &&
          this.targetFields["npi_num"]["required"] &&
          $("option:selected", event.target).data("npi_required") == 1
        ) {
          this.dom
            .find("#npi_num")
            .prop("required", true)
            .addClass("required is-invalid");
        } else {
          this.dom
            .find("#npi_num")
            .prop("required", false)
            .removeClass("required is-invalid");
        }
      }

      if (this.targetFields["degree_npi_license_flag"] ?? false) {
        const npi_required =
          this.dom.find("option:selected", event.target).data("npi_required") ==
          1;
        const license_required =
          this.dom
            .find("option:selected", event.target)
            .data("license_required") == 1;
        if (npi_required) {
          this.dom
            .find("#npi_num")
            .prop("required", true)
            .addClass("required is-invalid");
        } else {
          this.dom
            .find("#npi_num")
            .prop("required", false)
            .removeClass("required is-invalid");
        }

        if (license_required) {
          this.dom
            .find("#state_license")
            .prop("required", true)
            .addClass("required is-invalid");
        } else {
          this.dom
            .find("#state_license")
            .prop("required", false)
            .removeClass("required is-invalid");
        }
      }
    });

    this.dom.find("#npi_na").on("change", () => {
      if (this.dom.find("#npi_na").prop("checked")) {
        this.dom
          .find("#npi_num")
          .prop("required", false)
          .prop("disabled", true)
          .removeClass("required is-invalid")
          .val("");
      } else {
        this.dom
          .find("#npi_num")
          .prop("disabled", false)
          .prop("required", this.targetFields["npi_num"]["required"]);
        if (this.dom.find("#npi_num").prop("required")) {
          this.dom.find("#npi_num").addClass("required is-invalid");
        }
      }
    });

    this.dom.find("#target_form").on("submit", (event) => {
      event.preventDefault();
      let formData = {};
      this.dom
        .find("#target_form input, #target_form select")
        .each((index, elem) => {
          if ($(elem).prop("type") == "radio") {
            formData[$(elem).attr("name")] = $(
              "input[name=" + $(elem).attr("name") + "]:checked"
            ).val();
          } else if (
            $(elem).prop("type") != "checkbox" ||
            $(elem).is(":checked")
          ) {
            formData[$(elem).attr("name")] = $(elem).val();
          }
        });
      if (formData["license_number"]) {
        formData["state_license"] = formData["license_number"];
        delete formData["license_number"];
      }
      // city, zip, state, validation
      let cityInput = this.dom.find("#city");
      let stateInput = this.dom.find("#state");
      let zipInput = this.dom.find("#zip");

      let countryValue = this.dom.find("#country").val().toLowerCase();
      if (countryValue === "us") {
        let isValid = true;

        let fieldsToCheck = [
          { input: cityInput, name: "City" },
          { input: stateInput, name: "State" },
          { input: zipInput, name: "Zip Code" },
        ];

        fieldsToCheck.forEach(function (field) {
          let fieldValue = formData[field.input.attr("id").toLowerCase()];
          if (!fieldValue) {
            field.input.prop("required", true);
            field.input.addClass("required is-invalid");
            field.input.attr(
              "title",
              "Please fill the " + field.name + " field"
            );
            isValid = false;
          }
        });

        if (!isValid) {
          return false;
        }
      }

      formData.attendedOverride = this.meetingPhase == 'postmeeting' ? 1 : 2;
      formData.hcp_compliance_check = this.meetingData.hcp_compliance_check;
      formData.product_ids = this.meetingData.product_ids;

      // Proceed with form submission if all validations pass
      $.ajax({
        url: "api/attendance/checkinvdegspec",
        method: "get",
        data: {
          degree: formData.degree,
          specialty: formData.specialty,
          meeting_id: $("#meeting_id").val(),
        },
      }).done((data) => {
        if (data.success === false && !$("#is_staff").length) {
          this.invalidMod = new CustomModal({
            title: data.title,
            content: "<p>" + data.message + "</p>",
            buttons: [
              {
                text: app.appData.layout.attendance.invalid_continue,
                id: "continuebtn",
                close: true,
                class: "btn-primary",
                action: () => {
                  this.submitFormData(event, formData);
                },
              },
              {
                text: "Cancel",
                id: "cancelbtn",
                close: true,
                class: "btn-primary",
              },
            ],
          });

          this.invalidMod.open();
        } else {
          this.submitFormData(event, formData);
        }
      });
    });

    if (app.appData.configs.ADDRESS_FIELDS_READONLY ?? false) {
      this.dom.on("keypress", "#country, #city, #zip", function (event) {
        if ($(this).prop("readonly")) {
          event.preventDefault();
          return;
        }
      });

      this.dom
        .find("#country, #city, #zip")
        .attr("onmousedown", "return false;")
        .attr("readonly", false)
        .attr("onkeydown", "event.preventDefault()")
        .addClass("readonly-field");

      this.dom.on("input", '[name="address1"]', () => {
        this.dom.find('[name="city"], [name="state"], [name="zip"]').val("");
        this.dom.find('[name="country"]').val("US");

        let cityInput = this.dom.find("#city");
        let stateInput = this.dom.find("#state");
        let zipInput = this.dom.find("#zip");
        cityInput
          .attr("onmousedown", "return false;")
          .attr("readonly", false)
          .attr("onkeydown", "event.preventDefault()")
          .prop("required", true);
        stateInput
          .attr("onmousedown", "return false;")
          .attr("readonly", false)
          .attr("onkeydown", "event.preventDefault()")
          .prop("required", true);
        zipInput
          .attr("onmousedown", "return false;")
          .attr("onkeydown", "event.preventDefault()")
          .attr("readonly", false)
          .prop("required", true);
      });
    }
    this.dom.on(
      "click",
      '[name="address1"]',
      function () {
        this.dom
          .find("#city")
          .prop("required", false)
          .removeClass("pattern-valid");
        this.dom
          .find("#state")
          .prop("required", false)
          .removeClass("pattern-valid");
        this.dom
          .find("#zip")
          .prop("required", false)
          .removeClass("pattern-valid");
        return false;
      }.bind(this)
    );

    this.dom.on(
      "input change",
      "#address1, select",
      function () {
        this.dom.find("#city").prop("required", true).addClass("pattern-valid");
        this.dom
          .find("#state")
          .prop("required", true)
          .addClass("pattern-valid");
        this.dom.find("#zip").prop("required", true).addClass("pattern-valid");
      }.bind(this)
    );

    this.modal = new bootstrap.Modal(this.dom, {
      backdrop: "static",
      keyboard: false,
      focus: false,
    });

    this.modal.show();
  }

  submitFormData(event, formData) {
    $.ajax({
      url: "api/attendance/registertargetattendee",
      method: "post",
      data: {
        data: formData,
        meeting_id: $("#meeting_id").val(),
      },
    }).done((data) => {
      if (data.success) {
        app.pages.attendance.dom.trigger("participantAdded", [event, formData]);
        this.modal.hide();
        if (
          typeof app.appData.layout.meeting_request
            .approval_email_after_min_att !== "undefined" &&
          app.appData.layout.meeting_request.approval_email_after_min_att
        ) {
          this.sendApprovalEmail();
        }
      } else if (data.message) {
        $(".attendee-val-message > span").html(
          data.message + "<br>Click this message to hide it."
        );
        $(".attendee-val-message").show();
      } else {
        app.pages.attendance.dom.trigger("failedAddByEmail", [event, formData]);
        this.modal.hide();
      }
    });
  }

  setFormVals() {
    Object.keys(this.attendeeData).forEach((key) => {
      if (key === "state") {
        this.buildStateDD(
          this.dom.find("#state-dd-container"),
          "state",
          this.attendeeData["country"],
          this.attendeeData[key]
        );
      } else {
        const $input = this.dom.find("#" + key);
        $input.val(this.attendeeData[key]);
      }
    });
  }

  buildStateDD(stateContainer, ddName, countryCode, selectedStateCode) {
    countryCode = countryCode || "US";
    selectedStateCode = selectedStateCode || "";
    $.ajax({
      url: "api/states/" + countryCode,
      method: "get",
    }).done((data) => {
      stateContainer.empty();
      this.stateDD = new Dropdown(data)
        .addClass("input-group-text")
        .addClass("form-control-sm")
        .addClass("address-field")
        .addClass(
          this.targetFields[ddName]["required"] ? "required is-invalid" : ""
        )
        .label("Select a state...")
        .required(this.targetFields[ddName]["required"] || false)
        .draw(stateContainer, "alpha2", "name", ddName);

      if (data.length == 1) {
        stateContainer.find("select").val(data[0].alpha2);
      }

      if (selectedStateCode != "") {
        stateContainer.find("select").val(selectedStateCode);
      }

      let $select = stateContainer.find("select");
      if ($select.hasClass("required")) {
        if ($select.val()) {
          $select.removeClass("is-invalid");
        } else {
          $select.addClass("is-invalid");
        }
      }

      if (app.appData.configs.ADDRESS_FIELDS_READONLY ?? false) {
        stateContainer.find("select").addClass("readonly-field");
        stateContainer.find("select").prop("readonly", true);
        stateContainer.find("select").attr("onmousedown", "return false;");
        stateContainer
          .find("select")
          .attr("onkeydown", "event.preventDefault()");
      }
    });
  }

  getPreviousAddresses() {
    return $.ajax({
      url: "api/attendance/getattendeeaddresses",
      method: "get",
      data: {
        meeting_id: $("#meeting_id").val(),
      },
    });
  }

  setupDropdowns() {
    let specialtyDD = new Dropdown(app.format.getSortedSpecialties());
    specialtyDD
      .addClass("input-group-text")
      .addClass("form-control-sm")
      .label("Select a specialty...")
      .draw(
        this.dom.find("#specialty-dd-container"),
        "code",
        "short_name",
        "specialty"
      );
    if (
      this.targetFields["specialty"] &&
      this.targetFields["specialty"]["autofill"]
    ) {
      this.dom.find("#specialty").select2({
        placeholder: "Select a specialty...",
        dropdownParent: this.dom.find(".modal-body"),
      });
    }

    let degrees = app.format.getSortedDegrees();
    degrees = degrees.filter((degree) => degree.active == "1");
    let degreeDD = new Dropdown(degrees);
    degreeDD
      .addClass("input-group-text")
      .addClass("form-control-sm")
      .label("Select a degree...")
      .draw(
        this.dom.find("#degree-dd-container"),
        "degree_abbrv",
        "degree_desc",
        "degree",
        ["npi_required", "is_prescriber", "license_required"]
      );
    if (
      this.targetFields["degree"] &&
      this.targetFields["degree"]["autofill"]
    ) {
      this.dom.find("#degree").select2({
        placeholder: "Select a degree...",
        dropdownParent: this.dom.find(".modal-body"),
      });
    }

    let titleDD = new Dropdown(app.appData.titles);
    titleDD
      .addClass("input-group-text")
      .addClass("form-control-sm")
      .label("Select a title...")
      .draw(this.dom.find("#title-dd-container"), "code", "name", "title");

    let countryDD = new Dropdown(app.appData.countries);
    countryDD
      .addClass("input-group-text")
      .addClass("form-control-sm")
      .addClass("address-field")
      .addClass("country-dd")
      .label("Select a country...")
      .draw(
        this.dom.find("#country-dd-container"),
        "alpha2",
        "name",
        "country"
      );
    this.dom.find("#country-dd-container > select").data({
      "state-dd-container": "state-dd-container",
      "state-dd-id": "state",
    });

    this.buildStateDD(this.dom.find("#state-dd-container"), "state", "US");

    if (this.targetFields.license_state !== undefined) {
      let licenseCountryDD = new Dropdown(app.appData.countries);
      licenseCountryDD
        .addClass("input-group-text")
        .addClass("form-control-sm")
        .addClass("country-dd")
        .label("Select a country...")
        .draw(
          this.dom.find("#license-country-dd-container"),
          "alpha2",
          "name",
          "license_country"
        );
      this.dom
        .find("#license-country-dd-container > select")
        .data({
          "state-dd-container": "license-state-dd-container",
          "state-dd-id": "license_state",
        })
        .val("US");

      this.buildStateDD(
        this.dom.find("#license-state-dd-container"),
        "license_state",
        "US"
      );
    }

    if (this.targetFields.license_state_number !== undefined) {
      let stateContainer = this.dom.find("#license-state-dd-container");
      let countryCode = "US";
      $.ajax({
        url: "api/states/" + countryCode,
        method: "get",
      }).done((data) => {
        stateContainer.empty();
        this.stateDD = new Dropdown(data)
          .addClass("input-group-text")
          .addClass("form-control-sm")
          .addClass("address-field")
          .label("Select a state...")
          .draw(stateContainer, "alpha2", "name", "license_state");

        if (data.length == 1) {
          stateContainer.find("select").val(data[0].alpha2);
        }
      });
    }

    this.getPreviousAddresses().done((data) => {
      let prevAddressDD = this.dom.find("#prev-addresses");
      prevAddressDD.empty();
      prevAddressDD.append('<option value=""></option>');
      data.data.forEach((address) => {
        let option = $(
          twig({
            data: "<option>{{ address1 }} {{address2}} {{city}}, {{state}} {{zip}}</option>",
          }).render(address)
        );
        option.data(address);
        prevAddressDD.append(option);
      });
    });

    let exact_match = false;
    let term = "";
    this.dom.find("#ship_to").select2({
      ajax: {
        url: "api/attendance/searchshipto",
        dataType: "json",
        data: (params) => {
          term = params.term.toUpperCase();

          return {
            query: params.term,
          };
        },
        method: "GET",
        processResults: (data) => {
          Object.keys(data).forEach((key) => {
            data[key]["id"] = data[key]["ship_to"].toUpperCase();
            data[key]["text"] = data[key]["customer_name"];

            if (data[key]["id"] === term) {
              exact_match = true;
            }
          });

          return {
            results: data,
          };
        },
        delay: 300,
      },
      templateResult: (data) => {
        if (data.ship_to && data.customer_name) {
          return (
            data.ship_to +
            ", " +
            data.customer_name +
            ", " +
            data.line_1 +
            ", " +
            data.city +
            ", " +
            data.state +
            ", " +
            data.zip
          );
        }
      },
      templateSelection: (data) => {
        if (data.ship_to && data.customer_name) {
          return (
            data.ship_to +
            ", " +
            data.customer_name +
            ", " +
            data.line_1 +
            ", " +
            data.city +
            ", " +
            data.state +
            ", " +
            data.zip
          );
        } else {
          return "Please enter a ship to # or customer name to search";
        }
      },
      tags: true,
      createTag: (params) => {
        let tag = exact_match ? null : { id: params.term, text: params.term };

        exact_match = false;

        return tag;
      },
      minimumInputLength: 2,
      placeholder: "Please enter a ship to # or customer name to search",
      dropdownParent: this.dom.find(".modal-body"),
    });

    this.dom.find("#ship_to").on("select2:open", () => {
      document.querySelector(".select2-search__field").focus();
    });
  }

  setRequiredFields() {
    Object.keys(this.targetFields).forEach((fieldId) => {
      let field = this.targetFields[fieldId];

      if (field["required"]) {
        this.dom
          .find("#" + fieldId)
          .prop("required", true)
          .addClass("required is-invalid");
      }
    });
  }

  checkRequired() {
    this.dom.find("#target_form .required").each((index, elem) => {
      const field = $(elem);
      const fieldId = field.attr("name") || field.attr("id");
      const value = field.val();

      let validationMessage = "";
      if (this.irep_validations) {
        validationMessage = this.validateField(value, fieldId);
      }

      // If IREP validation is disabled or the validateField returns empty, fallback to basic required check
      if (!this.irep_validations || validationMessage === "") {
        // Basic required field validation
        if (!value) {
          validationMessage = `Invalid - ${fieldId} is required`;
        }
      }

      // If there is a validation message, add the "is-invalid" class, else remove it
      if (validationMessage) {
        field.addClass("is-invalid");
        field[0].setCustomValidity(validationMessage);
      } else {
        field.removeClass("is-invalid");
        field[0].setCustomValidity("");
      }
    });
  }

  populateHiddenFields() {
    this.dom.find("#target_form input[type='hidden']").each((index, elem) => {
      const key = $(elem).attr("id") || $(elem).attr("name");

      if (key && this.attendeeData[key]) {
        $(elem).val(this.attendeeData[key]);
      }
    });
  }

  toggleFields() {
    let customerId = this.dom.find("#customer_id").val();
    let isEditable = customerId === ""; // Editable if Customer ID is empty

    if (!isEditable) {
      const fields = ["firstname", "lastname", "degree"];
  
      fields.forEach(fieldId => {
        const field = this.dom.find(`#${fieldId}`);
        const value = field.val()?.trim() || "";
        const validationError = this.irep_validations
          ? this.validateField(value, fieldId)
          : "";

        if (value !== "" && validationError === "") {
          field
            .attr("onmousedown", "return false;")
            .attr("readonly", true)
            .attr("onkeydown", "event.preventDefault()")
            .addClass("readonly-field");
        } else {
          field
            .removeAttr("onmousedown readonly onkeydown")
            .removeClass("readonly-field");
        }
      });
    }
  }

  sendApprovalEmail() {
    $("#meeting_id").val();
    return $.ajax({
      url: "api/meeting/sendapprovalemail",
      method: "post",
      data: {
        meeting_id: $("#meeting_id").val(),
      },
    });
  }

  setRequiredForLicenseStateNumber() {
    let licenseNumberEl = this.dom.find("#license_number");
    let licenseStateEl = this.dom.find("#license_state");
    let state = this.dom.find("#license_state").val();
    let number = this.dom.find("#license_number").val();

    let hasState = state && state.trim() !== "";
    let hasNumber = number && number.trim() !== "";

    if (hasState !== hasNumber) {
      if (!hasNumber) {
        licenseNumberEl.prop("required", true).addClass("required is-invalid");
      } else {
        licenseNumberEl
          .prop("required", false)
          .removeClass("required is-invalid");
      }

      if (!hasState) {
        licenseStateEl.prop("required", true).addClass("required is-invalid");
      } else {
        licenseStateEl
          .prop("required", false)
          .removeClass("required is-invalid");
      }
    } else {
      licenseNumberEl
        .prop("required", false)
        .removeClass("required is-invalid");
      licenseStateEl.prop("required", false).removeClass("required is-invalid");
    }
  }

  getRequiredFields() {
    let requiredFields = {};
    let requiredKey = this.meetingPhase + "_required";
    let type = "target";
    if (
      app.appData.projects[this.meetingData.project_id].program_types[
        this.meetingData.program_type_id
      ].configuration.manage_attendance.questions
    ) {
      requiredFields =
        app.appData.projects[this.meetingData.project_id].program_types[
          this.meetingData.program_type_id
        ].configuration.manage_attendance.questions[type][requiredKey] || {};
    }

    return requiredFields;
  }

  validateEitherEmailOrWwidField() {
    let email = this.dom.find('input[name="email"]').val().trim();
    let wwid = this.dom.find('input[name="wwid"]').val().trim();
    if (email !== "" || wwid !== "") {
      this.dom
        .find('input[name="email"]')
        .prop("required", false)
        .removeClass("required is-invalid");
      this.dom
        .find('input[name="wwid"]')
        .prop("required", false)
        .removeClass("required is-invalid");
    } else {
      this.dom
        .find('input[name="email"]')
        .prop("required", true)
        .addClass("required");
      this.dom
        .find('input[name="wwid"]')
        .prop("required", true)
        .addClass("required");
    }
  }

  /**
   * Validates the email format using a standard regex pattern.
   */
  validateEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(String(email).toLowerCase());
  }

  /**
   * Validates the email input field and applies custom validity and styling.
   */
  checkInvalidEmail() {
    const input = this.dom.find('input[name="email"]');
    const email = input.val().trim();
    const isEmailRequired = this.targetFields?.email?.required ?? false;

    if (isEmailRequired && email === "") {
      input[0].setCustomValidity("Email is required.");
      input.prop("required", true).addClass("required is-invalid");
    } else if (email !== "" && !this.validateEmail(email)) {
      input[0].setCustomValidity("Please enter a valid email.");
      input.prop("required", isEmailRequired).addClass("required is-invalid");
    } else {
      input[0].setCustomValidity("");
      input
        .prop("required", isEmailRequired)
        .removeClass("required is-invalid");
    }
  }

  validateNpiNumber(npi) {
    if (typeof npi == "undefined" || npi == "") {
      return true;
    }

    npi = npi.split("");
    let checkBit = parseInt(npi.pop()),
      npiDouble = [],
      npiUnchanged = [];
    npi.reverse();

    for (let i = 0; i < npi.length; i++) {
      if (i % 2 === 0) {
        npiDouble.push(npi[i] * 2);
      }

      if (i % 2 === 1) {
        npiUnchanged.push(npi[i]);
      }
    }

    npiDouble = npiDouble.toString().replace(/,/g, "");
    npiUnchanged = npiUnchanged.toString().replace(/,/g, "");
    let total = npiUnchanged + npiDouble,
      totalSum = 0;

    for (let i = 0; i < total.length; i++) {
      totalSum += parseInt(total.charAt(i));
    }

    totalSum += 24; // Magic Number
    var final = Math.ceil(totalSum / 10) * 10;
    return final - totalSum === checkBit;
  }

  /**
   * Checks if the NPI number is valid based on the field's requirement in targetFields.
   * Sets custom validity, disables submit button, and applies invalid styles if the NPI number is invalid.
   */
  checkInvalidNpiNumber(npi_number) {
    if (typeof npi_number == 'undefined') {
      return true;
    }
    
    const inputElement = this.dom.find("#npi_num")[0];
    const isNpiRequired = this.targetFields?.["npi_num"]?.required ?? false;
  
    const isEmpty = !npi_number || npi_number.trim() === "";

    // Only validate if #npi_na is NOT checked
    if (this.dom.find("#npi_na").prop("checked")) {
      this.dom.find("#npi_num").removeClass("is-invalid").prop("required", false);
      inputElement.setCustomValidity("");
      return true;
    }
  
    if (isNpiRequired && isEmpty) {
      inputElement.setCustomValidity("NPI Number is required.");
      this.dom.find("#npi_num").addClass("is-invalid").prop("required", true);
      return false;
    }
  
    const isValidFormat = /^[\d]{10}$/.test(npi_number);
    const isValidNpi = this.validateNpiNumber(npi_number);
  
    if (!isEmpty && (!isValidFormat || !isValidNpi)) {
      inputElement.setCustomValidity(
        "NPI must be 10-digits. Special characters and NA values are not allowed."
      );
      this.dom.find("#npi_num").addClass("is-invalid").prop("required", true);
      return false;
    }
  
    inputElement.setCustomValidity("");
    this.dom.find("#npi_num").removeClass("is-invalid").prop("required", isNpiRequired);
    return true;
  }

  generateFieldConfig(questions, questions_required) {
    const result = {};

    for (const key in questions) {
      if (questions[key] === true) {
        result[key] = {
          required: !!questions_required[key],
        };
      }
    }

    return result;
  }

  getQuestionFields() {
    let questions = {};
    if (
      app.appData.projects[this.meetingData.project_id].program_types[
        this.meetingData.program_type_id
      ].configuration.manage_attendance.questions
    ) {
      questions =
        app.appData.projects[this.meetingData.project_id].program_types[
          this.meetingData.program_type_id
        ].configuration.manage_attendance.questions[this.type][
          this.meetingPhase
        ] || {};

      if (
        typeof app.appData.serviceTypes[this.meetingData.service_id] ==
          "undefined" ||
        !parseInt(
          app.appData.serviceTypes[this.meetingData.service_id].has_meals
        )
      ) {
        delete questions["had_meal"];
      }
    }
    return questions;
  }

  mergeObjects(obj1, obj2) {
    const merged = {};

    // Combine all keys from both objects
    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    keys.forEach((key) => {
      if (obj1[key] && obj2[key]) {
        // Both objects have the key
        merged[key] = {
          ...obj1[key],
          ...obj2[key],
          required: obj1[key].required || obj2[key].required,
        };
      } else {
        // Only one object has the key
        merged[key] = obj1[key] || obj2[key];
      }
    });

    return merged;
  }

  validateField(value, fieldId)
  {
    const isRequired = this.targetFields[fieldId]?.required ?? false;
    const country = this.dom.find("#country").val()?.toUpperCase() ?? "US";
    const capitalizedField =
      (fieldId || "").charAt(0).toUpperCase() + (fieldId || "").slice(1);

    if (!value) {
      return isRequired
        ? `Invalid - ${
            fieldId === "firstname"
              ? "First"
              : fieldId === "lastname"
              ? "Last"
              : capitalizedField
          } is required`
        : "";
    }

    // Names Validation
    if (["firstname", "lastname"].includes(fieldId)) {
      if (
        fieldId === "lastname" &&
        value.length < 2 &&
        !["U", "O"].includes(value.charAt(0))
      ) {
        return "Invalid - Last Name <2 characters must start with 'U' or 'O'";
      }

      if (!/^[A-Za-z\-']{2,}$/.test(value)) {
        return 'Invalid - !@#$%^&*()_+=`[]{}\\|;:",.<>/?1234567890 special characters and numbers not allowed';
      }

      if (/\b(Dr|MD)\b/i.test(value)) {
        return `Invalid - ${
          fieldId === "firstname" ? "First" : "Last"
        } Name cannot contain "Dr" or "MD"`;
      }

      if (
        /^Mc/i.test(value) &&
        value.length > 2 &&
        value.charAt(2) !== value.charAt(2).toUpperCase()
      ) {
        return `Invalid - Third letter of ${
          fieldId === "firstname"
            ? "First"
            : fieldId === "lastname"
            ? "Last"
            : capitalizedField
        } Name should be uppercase when First Name starts with "Mc" (e.g., McLoud)`;
      }

      return "";
    }

    // Skip address/city/state/zip validation if country is not US
    if (
      ["address1", "address2", "city", "state", "zip"].includes(fieldId) &&
      country !== "US"
    ) {
      return "";
    }

    // Address Validation
    if (["address1", "address2"].includes(fieldId)) {
      if (/\b(?:Apt|Box)\b/i.test(value)) {
        return "Invalid - No Apt and Box allowed";
      }

      if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
        return "Invalid - No special characters allowed";
      }

      if (
        fieldId === "address1" &&
        (!/[a-zA-Z]/.test(value) || !/\d/.test(value))
      ) {
        return "Invalid - Enter at least one number and one letter.";
      }

      return "";
    }

    // City/State Validation
    if (["city"].includes(fieldId)) {
      if (/\d/.test(value)) {
        return `Invalid - ${capitalizedField} cannot contain numbers`;
      }

      if (!/^[a-zA-Z\s]+$/.test(value)) {
        return `Invalid - ${capitalizedField} cannot contain special characters`;
      }

      return "";
    }

    // ZIP Validation (only for US)
    if (fieldId === "zip") {
      if (!/^\d{5}(-\d{4})?$/.test(value)) {
        return "Invalid - ZIP must be 5 digits or ZIP+4 format (12345 or 12345-6789). No other special characters allowed.";
      }
      return "";
    }

    return ""; // No rules defined for this field
  }
}
